import { noop } from '@nfctron/nexus-core';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient, createNfctronApiRequestParams } from '@root/features/api-client/api-client';
import { useApiClient } from '@root/features/api-client/api-client.context';
import { useSessionStore } from '@root/features/authentication/stores/sessionStore';

/** custom hook for logout functionality */
export const useLogout = () => {
	/** get session store methods */
	const { setAccount, setIsAuthenticated } = useSessionStore();

	/** get api clients */
	const { passApi, rootApi } = useApiClient();

	/** query client */
	const queryClient = useQueryClient();

	/** return mutation hook */
	return useMutation({
		/** mutation function to handle user logout */
		async mutationFn() {
			/** immediately logout the user (optimistically) */
			setAccount(null);
			setIsAuthenticated(false);

			/** send POST request to logout endpoint */
			return apiClient
				.post('/api/auth/logout', null, {
					baseURL: '/',
					...createNfctronApiRequestParams(passApi.nfctronApiParams ?? {}),
				})
				.catch(noop);
		},
		/** reset session state and invalidate all queries */
		onSettled() {
			setAccount(null);
			setIsAuthenticated(false);

			/** invalidate all queries */
			queryClient.invalidateQueries();
			queryClient.removeQueries({ queryKey: ['activeSession'] });

			/** update passApi and rootApi clients with security data */
			passApi.setSecurityData(null);
			rootApi.setSecurityData(null);
		},
		/** error callback to handle logout errors */
		onError(error: Error) {
			console.error('Logout error:', error.message);
		},
	});
};
